import { RenderFieldExtensionCtx } from "datocms-plugin-sdk";
import { ValidationParameter } from "./FieldExtensionConfigScreen";
import { useCallback, useEffect, useMemo } from 'react';

type Props = {
    ctx: RenderFieldExtensionCtx;
  };
  
  export function CustomFieldExtension({ ctx }: Props) {
    const dependencies = JSON.parse((ctx.parameters as ValidationParameter).dependencies);
    const targetFieldsApiKey = Object.values(dependencies).flat() as string[];
    const sourceField = ctx.field;

    const targetFields = useMemo(() => {
        return targetFieldsApiKey
          .map((targetFieldApiKey) => {
            const targetField = Object.values(ctx.fields).find(
              (field) => field?.attributes.api_key === targetFieldApiKey,
            );
    
            if (!targetField) {
              console.error(
                `Plugin error: The field "${targetFieldApiKey}" does not exist`,
              );
              return null;
            }
    
            return targetField;
          })
          .filter((x) => x);
      }, [ctx.fields, targetFieldsApiKey]);

      const disableFields = useCallback(
        (currentValue: string, dependencies) => {

            if(ctx.isSubmitting)  
              return;

            const map =new Map<string,string[]>(Object.entries(dependencies));
                        
            if(!currentValue){
                targetFields.forEach(async (targetField) => {
                    if(targetField){
                      const path = targetField.attributes.api_key;
                      const value = ctx.formValues[targetField.attributes.api_key];
                      ctx.disableField(path, true);
                      if(value){
                        ctx.setFieldValue(path, null);
                      }
                    }
                  });
            } else {
                const selectTargetFieldsApiKey = map.get(currentValue.toLowerCase());
                targetFields.forEach( async (targetField) => {
                    if(targetField){
                        const path = targetField.attributes.api_key;
                        if(selectTargetFieldsApiKey?.find(targetFieldApiKey => targetFieldApiKey === path)){
                            ctx.disableField(path, false);
                        } else {
                          ctx.disableField(path, true);
                          const value = ctx.formValues[targetField.attributes.api_key];
                          if(value){
                            ctx.setFieldValue(path, null);
                          }
                        }
                    }
                  });
            }

      }, [ctx, targetFields]);

      const currentValue = ctx.formValues[sourceField.attributes.api_key] as string;
      
      useEffect(() => {
        disableFields(currentValue, dependencies);
      }, [currentValue, dependencies, disableFields]);
      
    return null;
  }
